import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { TranslocoService } from '@ngneat/transloco';

@Injectable()
export class APIInterceptor implements HttpInterceptor {
    constructor(private translocoService: TranslocoService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.startsWith('api/')) {
            const apiReq = req.clone({
                url: `${environment.https ? "https" : "http"}://${environment.api}/${req.url}`,
                headers: req.headers.set('Selected-Language', `${this.translocoService.getActiveLang()}`),
            });
            return next.handle(apiReq);
        }

        return next.handle(req);
    }
}
